import React from "react";
import { DownloadSimple } from "@phosphor-icons/react";
import { API } from "@/api";
import { Button } from "@/components/ui/button";

export default function AttendeesAdmin() {
  const download = () => {
    fetch(`${API}/admin/attendees.csv`, { credentials: "include" })
      .then((r) => r.blob())
      .then((blob) => {
        const u = URL.createObjectURL(blob);
        const a = document.createElement("a"); a.href = u; a.download = "dftb26-attendees.csv"; a.click();
        URL.revokeObjectURL(u);
      });
  };
  return (
    <div className="p-4 bg-[#FFFFFF] border border-[#E5E9F0] rounded-sm">
      <h3 className="font-display text-lg mb-2">Export attendees</h3>
      <p className="text-sm text-[#5a5a5a] mb-3">Download a CSV of all registered attendees (name, email, role, organisation, opt-in status).</p>
      <Button onClick={download} className="rounded-sm bg-[#000000] text-[#FFFFFF] hover:bg-[#1c1c24]" data-testid="admin-export-attendees"><DownloadSimple size={16} className="mr-1" /> Download CSV</Button>
    </div>
  );
}
